import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BillingInfo = ({ billingInfo }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.InfoContainer>
      <Styles.InfoTitle>{t('Datos de facturación')}</Styles.InfoTitle>
      <div>
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Nombre empresa')}
        </Text>
        <Text type="bodyMRegular">
          {billingInfo?.business_name_1} {billingInfo?.business_name_2}
        </Text>
      </div>
      <div>
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Email')}
        </Text>
        <Text type="bodyMRegular">{billingInfo?.email}</Text>
      </div>
      <div>
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Teléfono')}
        </Text>
        {billingInfo?.business_address?.phone?.number && (
          <Text type="bodyMRegular">
            +{billingInfo?.business_address?.phone?.prefix} {billingInfo?.business_address?.phone?.number}
          </Text>
        )}
      </div>
      <div>
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Dirección')}
        </Text>
        <div>
          <Text type="bodyMRegular">{billingInfo?.business_address?.line_1}</Text>
          <Text type="bodyMRegular">
            {billingInfo?.business_address?.line_2} {billingInfo?.business_address?.postcode}{' '}
            {billingInfo?.business_address?.locality} {billingInfo?.business_address?.province?.name}
          </Text>
          <Text type="bodyMRegular">{billingInfo?.business_address?.country?.name}</Text>
        </div>
      </div>
    </Styles.InfoContainer>
  )
}

export default BillingInfo
